<template>
    <div class="carBox" @mouseup="handleMouseUp">
        <el-card ref="left_tree" class="box-card" style="height: calc(100vh - 152px);width: 280px;overflow-y: auto">
            <el-tree :data="projectDivisionData" node-key="value" :current-node-key="pid" :highlight-current="true" ref="my-tree" @node-click="clickPrjectDivision" :default-expanded-keys="openKeys" :expand-on-click-node="false">
                <span slot-scope="{ node }" class="custom-tree-node treeTitle" :title="node.label.split('###')[3]">
                    {{node.label.split('###')[0]}}
                    <span :class="'treeTitleNum'+node.label.split('###')[1]">{{node.label.split('###')[2]}}</span>
                </span>
            </el-tree>
        </el-card>
        <div ref="resizeHandle" class="handle-resize" />
        <div ref="moveDiv" class="handle-resize-h" />
        <el-card class="box-card" style="width: calc(100% - 320px)">
            <div class="mainBody">
                <div class="dataBox" v-if="list_model ==0">
                    <el-alert title="请先选择分部工程" type="warning" center :closable="false" show-icon style="height: 60px;"></el-alert>
                </div>
                <div style="width: 100%; color: #606266" v-if="list_model ==1">
                    <div style="width: 100%; display: flex;flex-direction: row;align-items: center;justify-content: center;">
                        <el-button type="primary"  @click="info" >查看统计结果</el-button>
                    </div>
                </div>
                <div class="titleBoxwhr" v-if="list_model ==2">
                    <h3>
                        分部工程：{{branch.name}}
                    </h3>
                    <el-button style="margin-left: 50px" @click="back()">返回</el-button>
                    <el-button type="primary" style="margin-left: 10px" @click="expport()">导出</el-button>
                </div>
                <el-tabs v-model="grout_type" type="card" @tab-click="changeTabs" v-if="list_model ==2" style="width: 100%;margin-top: 25px">
                    <el-tab-pane label="固结灌浆" name="1"></el-tab-pane>
                    <el-tab-pane label="帷幕灌浆" name="2"></el-tab-pane>
                    <el-tab-pane label="回填灌浆" name="3"></el-tab-pane>
                </el-tabs>
                <el-card class="box-card" style="height: 100%" v-if="list_model ==2">
                    <el-radio-group v-model="echarts_show" size="small" @input="changeEcharts">
                        <el-radio-button label="1">注浆量</el-radio-button>
                        <el-radio-button label="2">注灰量/单位注灰量</el-radio-button>
                        <el-radio-button label="3">透水率</el-radio-button>
                        <el-radio-button label="4">工程量</el-radio-button>
                    </el-radio-group>
                    <div class="echarts1" id="myChart1">
                        
                    </div>
                </el-card>
                
                <el-card class="box-card" style="height: 100%;margin-top: 25px" v-if="list_model ==2">
                    <el-table :data="tableData1" border stripe>
                        <el-table-column prop="unit" label="单元"></el-table-column>
                        <el-table-column prop="report_count" label="报告数量"></el-table-column>
                        <el-table-column prop="report_count_err" label="异常报告数量"></el-table-column>
                        <el-table-column prop="grout_type_str" label="灌浆类型"></el-table-column>
                        <el-table-column prop="all_length" label="工程量(m)" v-if="grout_type == '3'"></el-table-column>
                        <el-table-column prop="all_length" label="工程量(m)" v-else></el-table-column>
                        <el-table-column prop="hole_count" label="灌浆孔数"></el-table-column>
                        <el-table-column prop="grout_volume" label="注浆量(L)"></el-table-column>
                        <el-table-column prop="grout_volume1" label="监测注浆量(L)"></el-table-column>
                        <el-table-column prop="grout_volume_cha" label="差异值(L)"></el-table-column>
                        <el-table-column prop="ash_volume" label="注灰量(Kg)"></el-table-column>
                        <el-table-column prop="ash_volume1" label="监测注灰量(Kg)"></el-table-column>
                        <el-table-column prop="ash_volume_cha" label="差异值(Kg)"></el-table-column>
                        <el-table-column prop="ash_volume_unit" label="单位注灰量(kg/m)" v-if="grout_type=='3'"></el-table-column>
                        <el-table-column prop="ash_volume_unit" label="单位注灰量(kg/m)" v-else></el-table-column>
                        <el-table-column prop="ash_volume_unit1" label="监测单位注灰量(kg/m)" v-if="grout_type=='3'"></el-table-column>
                        <el-table-column prop="ash_volume_unit1" label="监测单位注灰量(kg/m)" v-else></el-table-column>
                        <el-table-column prop="ash_volume_unit_cha" label="差异值(kg/m)" v-if="grout_type=='3'"></el-table-column>
                        <el-table-column prop="ash_volume_unit_cha" label="差异值(kg/m)" v-else></el-table-column>
                        <el-table-column prop="hole_count_ys" label="压水孔数"></el-table-column>
                        <el-table-column prop="permeable_rate" label="透水率(Lu)"></el-table-column>
                        <el-table-column prop="permeable_rate1" label="监测透水率(Lu)"></el-table-column>
                        <el-table-column prop="permeable_rate_cha" label="差异值(Lu)"></el-table-column>
                    </el-table>
                </el-card>
            </div>
        </el-card>
    </div>
</template>

<script>
import listutil from "@/libs/listutil"
import { getProjectDivisionTreeData } from '@/api/org'
import { checkBranch, branchVerifyData, exportBranchVerifyData } from '@/api/statistic'

// 引入基本模板
let echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/bar')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/grid')
require('echarts/lib/component/legend')
require('echarts/lib/component/title')

export default {
    name: 'branchverifycheck',
    mixins: [listutil],
    data() {
        return {
            m_name: '监测分部统计对比分析',
            menu_id: 6530,
            enu_name: ['grout_type'],
            grade: 1,
            pid: 0,
            projectDivisionData: [],
            openKeys: [],
            list_model: 0,
            segment_no: '',
            tableData1: [],
            branch: {},
            echarts_show: 0,
            option: {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {},
                grid: {
                    left: '4%',
                    right: '4%',
                    bottom: '0',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    name:'',
                    type: 'value'
                },
                series: [
                    {
                        name: '',
                        type: 'bar',
                        data: []
                    },
                    {
                        name: '',
                        type: 'bar',
                        data: []
                    }
                ]
            },
            option1: {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {},
                grid: {
                    left: '4%',
                    right: '4%',
                    bottom: '0',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: [{
                    name:'',
                    type: 'value'
                },{
                    name:'',
                    type: 'value'
                }],
                series: [
                    {
                        name: '',
                        type: 'bar',
                        yAxisIndex: 0,
                        data: []
                    },
                    {
                        name: '',
                        type: 'bar',
                        yAxisIndex: 0,
                        data: []
                    },
                    {
                        name: '',
                        type: 'bar',
                        yAxisIndex: 1,
                        data: []
                    },
                    {
                        name: '',
                        type: 'bar',
                        yAxisIndex: 1,
                        data: []
                    }
                ]
            },
            grout_type: '1',
        };
    },
    mounted(){
        this.dragControllerDiv(this.$refs.left_tree.$el, this.$refs.resizeHandle, this.$refs.moveDiv)
    },
    methods: {
        getData() {
            this.initTree()
        },
        initTree(){
            this.projectDivisionData = []
            getProjectDivisionTreeData(15).then(res=>{
                if(res.code ==1){
                    var treeData = res.data
                    treeData = this.removeEmptyChild(treeData)
                    this.projectDivisionData = treeData
                    this.initOpenKeys()
                }
            })
        },
        initOpenKeys(){//哪些节点要展开
            this.openKeys = this.getAllNodeId(this.openKeys, this.projectDivisionData, 0)
        },
        getAllNodeId (expandedKeys, moduleDataList, level) {
            if(level>1){
                return expandedKeys
            }
            for (let i = 0; i < moduleDataList.length; i++) {
                expandedKeys.push(moduleDataList[i].value)
                if (moduleDataList[i].children) {
                    expandedKeys = this.getAllNodeId(expandedKeys, moduleDataList[i].children, level+1)
                }
            }
            return expandedKeys
        },
        clickPrjectDivision(data){
            this.pid = data.id
            this.current = 1
            checkBranch(this.pid).then(res=>{
                if(res.code == 1){
                    this.list_model = 1
                }else{
                    this.list_model = 0
                    this.$msg(res.msg)
                }
            })
        },
        info() {
            this.list_model = 2
            const loading = this.$loading({
                lock: true,
                text: '正在执行...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            branchVerifyData(this.pid, 2).then(res=>{
                loading.close()
                if(res.code == 1){
                    this.tableData1 = res.data.list1
                    this.list1 = res.data.list1
                    this.list2 = res.data.list2
                    this.list3 = res.data.list3
                    this.branch = res.data.branch
                    this.line1_1 = res.data.line1_1
                    this.line2_1 = res.data.line2_1
                    this.line3_1 = res.data.line3_1
                    this.line4_1 = res.data.line4_1
                    this.line5_1 = res.data.line5_1
                    this.line11_1 = res.data.line11_1
                    this.line21_1 = res.data.line21_1
                    this.line31_1 = res.data.line31_1
                    this.line41_1 = res.data.line41_1
                    this.line51_1 = res.data.line51_1
                    this.line1_2 = res.data.line1_2
                    this.line2_2 = res.data.line2_2
                    this.line3_2 = res.data.line3_2
                    this.line4_2 = res.data.line4_2
                    this.line5_2 = res.data.line5_2
                    this.line11_2 = res.data.line11_2
                    this.line21_2 = res.data.line21_2
                    this.line31_2 = res.data.line31_2
                    this.line41_2 = res.data.line41_2
                    this.line51_2 = res.data.line51_2
                    this.line1_3 = res.data.line1_3
                    this.line2_3 = res.data.line2_3
                    this.line3_3 = res.data.line3_3
                    this.line4_3 = res.data.line4_3
                    this.line5_3 = res.data.line5_3
                    this.line11_3 = res.data.line11_3
                    this.line21_3 = res.data.line21_3
                    this.line31_3 = res.data.line31_3
                    this.line41_3 = res.data.line41_3
                    this.line51_3 = res.data.line51_3
                    this.option.xAxis.data = res.data.xAxis1
                    this.option1.xAxis.data = res.data.xAxis1
                    this.xAxis1 = res.data.xAxis1
                    this.xAxis2 = res.data.xAxis2
                    this.xAxis3 = res.data.xAxis3
                    this.grout_type = '1'
                    this.echarts_show = '1'
                    this.changeEcharts('1')
                }
            })
        },
        back(){
            this.list_model = 0
            this.tableData1 = []
            this.grout_type = '1'
            this.echarts_show = '1'
            this.branch = {}
        },
        changeTabs(tab, event){
            if(this.grout_type == '1'){
                this.tableData1 = this.list1
            }else if(this.grout_type == '2'){
                this.tableData1 = this.list2
            }else if(this.grout_type == '3'){
                this.tableData1 = this.list3
            }
            this.changeEcharts(this.echarts_show)
        },
        changeEcharts(e){
            if(this.grout_type == '1'){
                this.option.xAxis.data = this.xAxis1
                this.option1.xAxis.data = this.xAxis1
                if(e =='1'){
                    this.option.yAxis.name = '注浆量(L)'
                    this.option.series[0].name = '注浆量(L)'
                    this.option.series[0].data = this.line1_1
                    this.option.series[1].name = '监测注浆量(L)'
                    this.option.series[1].data = this.line11_1
                }else if(e=='2'){
                    this.option1.yAxis[0].name = '注灰量(Kg)'
                    this.option1.yAxis[1].name = '单位注灰量(kg/m)'
                    this.option1.series[0].name = '注灰量(Kg)'
                    this.option1.series[0].data = this.line2_1
                    this.option1.series[1].name = '监测注灰量(Kg)'
                    this.option1.series[1].data = this.line21_1
                    this.option1.series[2].name = '单位注灰量(kg/m)'
                    this.option1.series[2].data = this.line3_1
                    this.option1.series[3].name = '监测单位注灰量(kg/m)'
                    this.option1.series[3].data = this.line31_1
                }else if(e=='3'){
                    this.option.yAxis.name = '透水率(Lu)'
                    this.option.series[0].name = '透水率(Lu)'
                    this.option.series[0].data = this.line4_1
                    this.option.series[1].name = '监测透水率(Lu)'
                    this.option.series[1].data = this.line41_1
                }else if(e=='4'){
                    this.option.yAxis.name = '工程量(m)'
                    this.option.series[0].name = '工程量(m)'
                    this.option.series[0].data = this.line5_1
                    this.option.series[1].name = '监测工程量(m)'
                    this.option.series[1].data = this.line51_1
                }
            }else if(this.grout_type == '2'){
                this.option.xAxis.data = this.xAxis2
                this.option1.xAxis.data = this.xAxis2
                if(e =='1'){
                    this.option.yAxis.name = '注浆量(L)'
                    this.option.series[0].name = '注浆量(L)'
                    this.option.series[0].data = this.line1_2
                    this.option.series[1].name = '监测注浆量(L)'
                    this.option.series[1].data = this.line11_2
                }else if(e=='2'){
                    this.option1.yAxis[0].name = '注灰量(Kg)'
                    this.option1.yAxis[1].name = '单位注灰量(kg/m)'
                    this.option1.series[0].name = '注灰量(Kg)'
                    this.option1.series[0].data = this.line2_2
                    this.option1.series[1].name = '监测注灰量(Kg)'
                    this.option1.series[1].data = this.line21_2
                    this.option1.series[2].name = '单位注灰量(kg/m)'
                    this.option1.series[2].data = this.line3_2
                    this.option1.series[3].name = '监测单位注灰量(kg/m)'
                    this.option1.series[3].data = this.line31_2
                }else if(e=='3'){
                    this.option.yAxis.name = '透水率(Lu)'
                    this.option.series[0].name = '透水率(Lu)'
                    this.option.series[0].data = this.line4_2
                    this.option.series[1].name = '监测透水率(Lu)'
                    this.option.series[1].data = this.line41_2
                }else if(e=='4'){
                    this.option.yAxis.name = '工程量(m)'
                    this.option.series[0].name = '工程量(m)'
                    this.option.series[0].data = this.line5_2
                    this.option.series[1].name = '监测工程量(m)'
                    this.option.series[1].data = this.line51_2
                }
            }else if(this.grout_type == '3'){
                this.option.xAxis.data = this.xAxis3
                this.option1.xAxis.data = this.xAxis3
                if(e =='1'){
                    this.option.yAxis.name = '注浆量(L)'
                    this.option.series[0].name = '注浆量(L)'
                    this.option.series[0].data = this.line1_3
                    this.option.series[1].name = '监测注浆量(L)'
                    this.option.series[1].data = this.line11_3
                }else if(e=='2'){
                    this.option1.yAxis[0].name = '注灰量(Kg)'
                    this.option1.yAxis[1].name = '单位注灰量(kg/m²)'
                    this.option1.series[0].name = '注灰量(Kg)'
                    this.option1.series[0].data = this.line2_3
                    this.option1.series[1].name = '监测注灰量(Kg)'
                    this.option1.series[1].data = this.line21_3
                    this.option1.series[2].name = '单位注灰量(kg/m²)'
                    this.option1.series[2].data = this.line3_3
                    this.option1.series[3].name = '监测单位注灰量(kg/m²)'
                    this.option1.series[3].data = this.line31_3
                }else if(e=='3'){
                    this.option.yAxis.name = '透水率(Lu)'
                    this.option.series[0].name = '透水率(Lu)'
                    this.option.series[0].data = this.line4_3
                    this.option.series[1].name = '监测透水率(Lu)'
                    this.option.series[1].data = this.line41_3
                }else if(e=='4'){
                    this.option.yAxis.name = '工程量(m)'
                    this.option.series[0].name = '工程量(m²)'
                    this.option.series[0].data = this.line5_3
                    this.option.series[1].name = '监测工程量(m²)'
                    this.option.series[1].data = this.line51_3
                }
            }
            var myChart1 = echarts.init(document.getElementById("myChart1"));
            myChart1.clear()
            if(e =='2'){
                myChart1.setOption(this.option1);
            }else{
                myChart1.setOption(this.option);
            }
        },
        expport(){
            const loading = this.$loading({
                lock: true,
                text: '正在执行...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            exportBranchVerifyData(this.pid, 2).then(res=>{
                loading.close()
                if(res.code == 1){
                    window.open(res.data)
                }else{
                    this.$msg(res.msg)
                }
            })
        },
    }
};
</script>
<style lang="less" scoped>
    .titleBoxwhr {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
    }
    .carBox .el-card:first-child /deep/ .el-card__body {
        padding: 20px 6px;
    }
    .el-table /deep/ .el-table__cell {
        padding: 10px 0;
    }
    .el-card /deep/ .el-card__header {
        padding: 10px 20px;
    }
    .echarts1{
        width: 100%;
        height: 250px;
        margin-top: 0;
    }
    .dataBox /deep/ .el-alert__title {
        font-size: 18px;
    }
</style>